(function () {
  if (customElements.get('model-picker')) return;

  var squish = function (s) { return s.split(' ').join('').split('-').join(''); };

  var scrollBehavior = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  };

  // ---- Name parsing -----------------------------------------------------
  // Turns a model name into the series a shopper filters by. Apple uses name
  // suffixes (Pro / Plus / Air / mini), most Android brands use a letter+number
  // code (S24, A54, V29, F25), and some use a family word (Note, Reno, GT).
  // `word: true` means the family must appear as its own word, so short codes
  // like GT never match inside another word.

  var FAMILIES = [
    { match: 'z fold', label: 'Z Fold' },
    { match: 'z flip', label: 'Z Flip' },
    { match: 'note', label: 'Note', word: true },
    { match: 'reno', label: 'Reno', word: true },
    { match: 'nord', label: 'Nord', word: true },
    { match: 'narzo', label: 'Narzo', word: true },
    { match: 'find', label: 'Find', word: true },
    { match: 'razr', label: 'Razr', word: true },
    { match: 'pixel', label: 'Pixel', word: true },
    { match: 'magic', label: 'Magic', word: true },
    { match: 'nova', label: 'Nova', word: true },
    { match: 'edge', label: 'Edge', word: true },
    { match: 'gt', label: 'GT', word: true },
    { match: 'fold', label: 'Fold', word: true },
    { match: 'flip', label: 'Flip', word: true },

    // Desktop Macs: without these, "Mac Mini M4" reads as "M Series".
    { match: 'mac mini', label: 'Mac Mini' },
    { match: 'mac studio', label: 'Mac Studio' },
    { match: 'imac', label: 'iMac', word: true },

    // Laptops group by product line, not by a number code. These must be
    // checked before the letter+digit rule, or "Elitebook 745 G7" would be
    // read as "G Series".
    { match: 'elitebook', label: 'EliteBook', word: true },
    { match: 'probook', label: 'ProBook', word: true },
    { match: 'pavilion', label: 'Pavilion', word: true },
    { match: 'spectre', label: 'Spectre', word: true },
    { match: 'envy', label: 'Envy', word: true },
    { match: 'omen', label: 'Omen', word: true },
    { match: 'victus', label: 'Victus', word: true },
    { match: 'chromebook', label: 'Chromebook', word: true },
    { match: 'zbook', label: 'ZBook', word: true },
    { match: 'inspiron', label: 'Inspiron', word: true },
    { match: 'latitude', label: 'Latitude', word: true },
    { match: 'vostro', label: 'Vostro', word: true },
    { match: 'precision', label: 'Precision', word: true },
    { match: 'alienware', label: 'Alienware', word: true },
    { match: 'xps', label: 'XPS', word: true },
    { match: 'thinkpad', label: 'ThinkPad', word: true },
    { match: 'thinkbook', label: 'ThinkBook', word: true },
    { match: 'ideapad', label: 'IdeaPad', word: true },
    { match: 'legion', label: 'Legion', word: true },
    { match: 'yoga', label: 'Yoga', word: true },
    { match: 'vivobook', label: 'VivoBook', word: true },
    { match: 'zenbook', label: 'ZenBook', word: true },
    { match: 'proart', label: 'ProArt', word: true },
    { match: 'tuf', label: 'TUF', word: true },
    { match: 'rog', label: 'ROG', word: true },
    { match: 'aspire', label: 'Aspire', word: true },
    { match: 'nitro', label: 'Nitro', word: true },
    { match: 'predator', label: 'Predator', word: true },
    { match: 'swift', label: 'Swift', word: true },
    { match: 'travelmate', label: 'TravelMate', word: true },
    { match: 'extensa', label: 'Extensa', word: true },

    // Last: the generic line. Without it, "HP Notebook 15s-BS644TU" falls to
    // the letter+digit rule and invents a pill per SKU prefix (BS, DA, DU...).
    { match: 'notebook', label: 'Notebook', word: true }
  ];

  var BRANDS = {
    samsung: 'Samsung', galaxy: 'Galaxy', vivo: 'Vivo', oppo: 'Oppo',
    realme: 'Realme', redmi: 'Redmi', xiaomi: 'Xiaomi', poco: 'Poco',
    oneplus: 'OnePlus', iqoo: 'iQOO', motorola: 'Motorola', moto: 'Moto',
    nothing: 'Nothing', google: 'Google', honor: 'Honor', huawei: 'Huawei',
    infinix: 'Infinix', tecno: 'Tecno', lava: 'Lava', nokia: 'Nokia',
    asus: 'Asus', rog: 'ROG', itel: 'Itel', micromax: 'Micromax', apple: 'Apple'
  };

  var isDigit = function (c) { return c >= '0' && c <= '9'; };
  var isLetter = function (c) { return c >= 'a' && c <= 'z'; };

  var tokenize = function (raw) {
    var lower = String(raw).toLowerCase();
    var cleaned = '';

    for (var i = 0; i < lower.length; i++) {
      var ch = lower.charAt(i);
      cleaned += '()-_,/+'.indexOf(ch) > -1 ? ' ' : ch;
    }

    var tokens = cleaned.split(' ').filter(function (t) { return t.length > 0; });
    var padded = ' ' + tokens.join(' ') + ' ';

    return {
      tokens: tokens,
      has: function (w) { return padded.indexOf(' ' + w + ' ') > -1; },
      contains: function (w) { return padded.indexOf(w) > -1; }
    };
  };

  // A budget variant written as digits plus a trailing letter, e.g. 17e, 12x.
  var budgetSuffix = function (tokens) {
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (t.length < 2 || t.length > 4) continue;
      if (!isDigit(t.charAt(0))) continue;

      var last = t.charAt(t.length - 1);
      if (isLetter(last) && last !== 'g') return true;
    }

    return false;
  };

  var detectSeries = function (raw) {
    var p = tokenize(raw);
    var has = p.has;
    var contains = p.contains;
    var i;

    if (contains('macbook')) {
      if (has('pro')) return 'MacBook Pro';
      if (has('air')) return 'MacBook Air';
      return 'MacBook';
    }

    if (contains('ipad')) {
      if (has('pro')) return 'iPad Pro';
      if (has('air')) return 'iPad Air';
      if (has('mini')) return 'iPad mini';
      return 'iPad';
    }

    if (contains('iphone')) {
      if (contains('pro max')) return 'Pro Max';
      if (has('pro')) return 'Pro';
      if (has('air')) return 'Air';
      if (has('plus')) return 'Plus';
      if (has('mini')) return 'Mini';
      if (has('se')) return 'SE';
      return 'Standard';
    }

    if (contains('watch')) return 'Watch';

    for (i = 0; i < FAMILIES.length; i++) {
      var f = FAMILIES[i];
      if (f.word ? has(f.match) : contains(f.match)) return f.label;
    }

    // Letter+number model code, e.g. S24 Ultra, A54, V29e, F25, C55, GT7.
    for (i = 0; i < p.tokens.length; i++) {
      var t = p.tokens[i];
      if (BRANDS[t]) continue;

      var letters = 0;
      while (letters < t.length && isLetter(t.charAt(letters))) letters++;

      if (letters > 0 && letters <= 3 && letters < t.length && isDigit(t.charAt(letters))) {
        return t.slice(0, letters).toUpperCase() + ' Series';
      }
    }

    // Purely numbered flagship, e.g. OnePlus 12 or Realme 11 Pro.
    for (i = 0; i < p.tokens.length; i++) {
      if (BRANDS[p.tokens[i]]) return BRANDS[p.tokens[i]];
    }

    return 'Other';
  };

  // Models that share one numbering run belong to the same line, so every
  // iPhone 17 variant sorts together instead of sitting in separate blocks.
  // Android numbering restarts per series, so each series stays its own line.
  var detectLine = function (raw, seriesKey) {
    var p = tokenize(raw);

    if (p.contains('iphone')) return 'apple-iphone';
    if (p.contains('ipad')) return 'apple-ipad';
    if (p.contains('macbook')) return 'apple-macbook';
    if (p.contains('watch')) return 'apple-watch';

    return seriesKey || 'other';
  };

  // Generation number used to sort newest first: S26 -> 26, iPhone 13 -> 13.
  // A release year stands in for models named after one, so SE (2022) lands
  // beside the 13 rather than at the very top.
  var detectGeneration = function (raw) {
    var p = tokenize(raw);
    var tokens = p.tokens;

    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (BRANDS[t]) continue;

      var j;
      var digits = '';

      // Leading digits: 13, 17e, 12x.
      if (isDigit(t.charAt(0))) {
        for (j = 0; j < t.length && isDigit(t.charAt(j)); j++) digits += t.charAt(j);

        var value = parseInt(digits, 10);
        if (value >= 1990 && value <= 2100) return value - 2009;
        if (value > 0 && value <= 40) return value;
        continue;
      }

      // Letter code then digits: s26, a54, v29.
      var letters = 0;
      while (letters < t.length && isLetter(t.charAt(letters))) letters++;

      if (letters > 0 && letters <= 3 && letters < t.length && isDigit(t.charAt(letters))) {
        for (j = letters; j < t.length && isDigit(t.charAt(j)); j++) digits += t.charAt(j);
        return parseInt(digits, 10);
      }
    }

    if (p.has('xs') || p.has('xr') || p.has('x')) return 10;
    if (p.has('se')) return 9;

    return 0;
  };

  // Within one generation the bigger model comes first:
  // Ultra / Pro Max, Pro, Air, Plus, base, e / FE / Lite, mini.
  var detectRank = function (raw) {
    var p = tokenize(raw);

    if (p.has('ultra')) return 12;
    if (p.contains('pro max')) return 12;
    if (p.has('pro')) return 10;
    if (p.has('max')) return 10;
    if (p.has('air')) return 9;
    if (p.has('plus')) return 8;
    if (p.has('fe') || p.has('lite')) return 4;
    if (budgetSuffix(p.tokens)) return 4;
    if (p.has('mini')) return 2;

    return 6;
  };

  // Laptop model numbers are screen sizes and SKU codes, not generations, so
  // sorting them newest-first is meaningless. These lines sort A to Z instead,
  // which reads naturally: Elitebook 745 G7, 840 G7, 840 G8, 845 G7.
  var LAPTOP_LINES = {
    'EliteBook': 1, 'ProBook': 1, 'Pavilion': 1, 'Spectre': 1, 'Envy': 1,
    'Omen': 1, 'Victus': 1, 'Chromebook': 1, 'ZBook': 1, 'Inspiron': 1,
    'Latitude': 1, 'Vostro': 1, 'Precision': 1, 'Alienware': 1, 'XPS': 1,
    'ThinkPad': 1, 'ThinkBook': 1, 'IdeaPad': 1, 'Legion': 1, 'Yoga': 1,
    'VivoBook': 1, 'ZenBook': 1, 'ProArt': 1, 'TUF': 1, 'ROG': 1,
    'Aspire': 1, 'Nitro': 1, 'Predator': 1, 'Swift': 1, 'TravelMate': 1,
    'Extensa': 1, 'Notebook': 1
  };

  var slug = function (s) { return s.toLowerCase().split(' ').join('-'); };

  // ---- Phone brand pages (12 Oct 2026) ------------------------------------
  // The classic rules above left gaps on phone brand pages: Pixel and Nothing got
  // no pills at all, every numbered OnePlus / Realme / iQOO sat in one pill named
  // after the brand, and a caveat like "(only back no edge to edge)" was read as
  // the Edge series. This reader works on what is left after the brand words are
  // removed, so EVERY model lands in a named series, with no hand-kept list of
  // series. Used when the section's "Series logic" is set to Phone brand page.
  // detectSeries above is left untouched: the WhatsApp menu and old
  // ?series= links still use its keys.

  var PHONE_BRAND_WORDS = {
    samsung: 'Samsung', galaxy: '', vivo: 'Vivo', iqoo: 'iQOO', oppo: 'Oppo',
    realme: 'Realme', redmi: 'Redmi', xiaomi: 'Xiaomi', mi: 'Xiaomi', poco: 'Poco',
    oneplus: 'OnePlus', motorola: 'Moto', moto: 'Moto', nothing: 'Nothing',
    google: 'Google', apple: 'Apple', asus: 'Asus', honor: 'Honor', huawei: 'Huawei',
    infinix: 'Infinix', tecno: 'Tecno', lava: 'Lava', nokia: 'Nokia', itel: 'Itel',
    micromax: 'Micromax', sony: 'Sony', lg: 'LG'
  };

  // Only spelling fixes for the label; a word missing here still works, it is
  // simply shown with a capital first letter.
  var PHONE_LABELS = {
    iphone: 'iPhone', rog: 'ROG Phone', gt: 'GT', cmf: 'CMF', xcover: 'XCover',
    zenfone: 'Zenfone', se: 'SE'
  };

  var leadingNumber = function (t) {
    var digits = '';
    for (var j = 0; j < t.length && isDigit(t.charAt(j)); j++) digits += t.charAt(j);
    return digits ? parseInt(digits, 10) : 0;
  };

  var trailingNumber = function (t) {
    var j = 0;
    while (j < t.length && isLetter(t.charAt(j))) j++;
    return j > 0 && j < t.length ? leadingNumber(t.slice(j)) : 0;
  };

  var capital = function (w) { return w.charAt(0).toUpperCase() + w.slice(1); };

  // Notes such as "(only back available)" describe the skin, not the model.
  var dropNotes = function (raw) {
    var out = '';
    var buf = '';
    var depth = 0;
    var text = String(raw).toLowerCase();

    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch === '(') { depth++; buf = ''; continue; }
      if (ch === ')' && depth > 0) {
        depth--;
        out += buf.trim().indexOf(' ') > -1 ? ' ' : ' ' + buf + ' ';
        buf = '';
        continue;
      }
      if (depth > 0) buf += ch; else out += ch;
    }

    return out + ' ' + buf;
  };

  // -> { family: 'Nord CE', key: 'nord-ce', gen: 4, numbered: false, brand: 'OnePlus' }
  var detectPhoneSeries = function (raw) {
    var all = tokenize(dropNotes(raw)).tokens;
    var tokens = [];
    var brand = '';

    all.forEach(function (t) {
      if (PHONE_BRAND_WORDS[t] !== undefined && tokens.length === 0) {
        if (PHONE_BRAND_WORDS[t]) brand = PHONE_BRAND_WORDS[t];
      } else {
        tokens.push(t);
      }
    });

    var result = function (family, gen, numbered) {
      return { family: family, key: slug(family), gen: gen || 0, numbered: !!numbered, brand: brand };
    };

    var numberAfter = function (from) {
      for (var i = from; i < tokens.length; i++) {
        var n = leadingNumber(tokens[i]) || trailingNumber(tokens[i]);
        if (n > 0 && n < 1000) return n;
      }
      return 0;
    };

    var t0 = tokens[0] || '';
    var t1 = tokens[1] || '';
    if (!t0) return result('Other', 0);

    // Numbered flagship: OnePlus 13R, Realme 12 Pro, Xiaomi 14, iQOO 9T.
    if (isDigit(t0.charAt(0))) return result('Numbered', leadingNumber(t0), true);

    // Two-word families.
    if (t0 === 'z' && t1.indexOf('fold') === 0) return result('Z Fold', numberAfter(1));
    if (t0 === 'z' && t1.indexOf('flip') === 0) return result('Z Flip', numberAfter(1));
    if (t0 === 'nord' && t1 === 'ce') return result('Nord CE', numberAfter(2));

    // A single letter on its own: Moto G, Moto G Play.
    if (t0.length === 1 && isLetter(t0)) return result(t0.toUpperCase() + ' Series', numberAfter(1));

    // Letter + number code: S25, A56, V50e, Y200, X7, C63.
    var letters = 0;
    while (letters < t0.length && isLetter(t0.charAt(letters))) letters++;
    if (letters > 0 && letters <= 3 && letters < t0.length && isDigit(t0.charAt(letters))) {
      return result(t0.slice(0, letters).toUpperCase() + ' Series', trailingNumber(t0));
    }

    // iPhone SE / XR / XS have no number; give them a named group.
    if (t0 === 'iphone') {
      if (t1 === 'se') return result('iPhone', -1);
      if (t1 === 'x' || t1 === 'xr' || t1 === 'xs') return result('iPhone', -2);
    }

    // Any other word is its own family: Note, Reno, Narzo, Edge, Razr, Neo,
    // Find, GT, Pixel, Phone, CMF ... including words nobody has listed yet.
    return result(PHONE_LABELS[t0] || capital(t0), numberAfter(1));
  };

  window.ModelPickerSeries = {
    detectPhone: detectPhoneSeries,
    detect: detectSeries,
    line: detectLine,
    generation: detectGeneration,
    rank: detectRank
  };

  // ---- Element ----------------------------------------------------------

  customElements.define('model-picker', class extends HTMLElement {
    connectedCallback() {
      this.rows = Array.prototype.slice.call(this.querySelectorAll('.mp__row'));
      this.grid = this.querySelector('.mp__grid');
      this.toolbar = this.querySelector('.mp__toolbar');
      this.pillWrap = this.querySelector('.mp__pills');
      this.input = this.querySelector('.mp__search');
      this.clearBtn = this.querySelector('.mp__clear');
      this.countEl = this.querySelector('[data-mp-count]');
      this.fab = this.querySelector('.mp__fab');
      this.topBtn = this.querySelector('[data-mp-top]');
      this.jumpBtn = this.querySelector('[data-mp-jump]');
      this.group = '';
      this.seriesOrder = {};

      this.phoneMode = this.getAttribute('data-series-mode') === 'phone';
      this.legacyGroup = false;

      var phoneMode = this.phoneMode;

      this.rows.forEach(function (r) {
        var name = r.getAttribute('data-name') || '';
        var series = detectSeries(name);
        r.squished = squish(name);
        r.generation = LAPTOP_LINES[series] ? 0 : detectGeneration(name);
        r.rank = LAPTOP_LINES[series] ? 6 : detectRank(name);
        r.seriesKey = slug(series);
        r.classicKey = r.seriesKey;
        r.lineKey = detectLine(name, r.seriesKey);

        if (phoneMode) {
          r.phone = detectPhoneSeries(name);
          r.seriesKey = r.phone.key;
          r.lineKey = r.phone.key;
        }
      });

      if (this.getAttribute('data-auto-series') === 'true') {
        if (phoneMode) this.buildPhonePills(); else this.buildSeriesPills();
      }
      if (this.getAttribute('data-sort') !== 'false') this.sortRows();

      this.pills = Array.prototype.slice.call(this.querySelectorAll('.mp__pill'));

      if (this.input) {
        this.input.addEventListener('input', this.apply.bind(this));
        this.input.addEventListener('keydown', this.onKey.bind(this));
      }

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          this.input.value = '';
          this.input.focus();
          this.apply();
        }.bind(this));
      }

      var moreBtn = this.querySelector('[data-mp-more]');
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          var open = this.pillWrap.getAttribute('data-open') === 'true';
          this.pillWrap.setAttribute('data-open', open ? 'false' : 'true');
          moreBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
          moreBtn.textContent = open ? moreBtn.getAttribute('data-more') : moreBtn.getAttribute('data-less');
        }.bind(this));
      }

      this.pills.forEach(function (p) {
        p.addEventListener('click', function () {
          this.legacyGroup = false;
          this.group = p.getAttribute('data-group') || '';
          this.pills.forEach(function (o) { o.setAttribute('aria-pressed', o === p ? 'true' : 'false'); });
          this.apply();
        }.bind(this));
      }.bind(this));

      if (this.topBtn) {
        this.topBtn.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: scrollBehavior() });
        });
      }

      if (this.jumpBtn) {
        this.jumpBtn.addEventListener('click', function () {
          var behavior = scrollBehavior();
          if (this.toolbar) this.toolbar.scrollIntoView({ behavior: behavior, block: 'start' });
          if (this.input) {
            var input = this.input;
            window.setTimeout(function () { input.focus({ preventScroll: true }); }, behavior === 'smooth' ? 420 : 0);
          }
        }.bind(this));
      }

      // Deep link from the WhatsApp menu (5 Oct 2026): ?series=a-series opens the page already
      // filtered to that series, even when it is not one of the visible pills.
      var wanted = '';
      try { wanted = new URLSearchParams(window.location.search).get('series') || ''; } catch (e) { wanted = ''; }
      // A ?series= link opens the page already filtered. Links made before 12 Oct 2026 (the
      // WhatsApp menu, built by menutree.py) use the classic series keys, and a classic key can
      // mean a different set of models than today's pill with the same name (classic "nord"
      // = Nord + Nord CE). So a classic key keeps its classic meaning, and the matching pill is
      // only lit when it shows exactly the same models.
      var sameKey = this.rows.filter(function (r) { return r.seriesKey === wanted || r.getAttribute('data-group') === wanted; });
      var classic = this.rows.filter(function (r) { return r.classicKey === wanted; });
      var samePill = classic.length === sameKey.length && classic.every(function (r) { return sameKey.indexOf(r) > -1; });

      if (wanted && sameKey.length && (!this.phoneMode || !classic.length || samePill)) {
        this.group = wanted;
        this.pills.forEach(function (o) {
          o.setAttribute('aria-pressed', o.getAttribute('data-group') === wanted ? 'true' : 'false');
        });
        var hit = this.pills.filter(function (o) { return o.getAttribute('data-group') === wanted; })[0];
        if (hit && hit.classList.contains('mp__pill--extra') && moreBtn) moreBtn.click();
      } else if (wanted && classic.length) {
        this.group = wanted;
        this.legacyGroup = true;
        this.pills.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      }

      this.observe();
      this.watchFab();
      this.apply();
    }

    // Reads the model names actually present and creates one pill per series.
    buildSeriesPills() {
      if (!this.pillWrap || this.rows.length === 0) return;

      var max = parseInt(this.getAttribute('data-max-pills'), 10) || 8;
      var counts = {};
      var labels = {};

      this.rows.forEach(function (r) {
        var label = detectSeries(r.getAttribute('data-name'));
        var key = slug(label);
        labels[key] = label;
        counts[key] = (counts[key] || 0) + 1;
      });

      var keys = Object.keys(counts).sort(function (a, b) {
        if (counts[b] !== counts[a]) return counts[b] - counts[a];
        return labels[a] < labels[b] ? -1 : 1;
      });

      // A single series means nothing to filter by.
      if (keys.length < 2) {
        this.pillWrap.hidden = true;
        return;
      }

      var kept = keys.slice(0, max);
      var self = this;

      kept.forEach(function (k, i) { self.seriesOrder[k] = i; });

      this.rows.forEach(function (r) {
        r.setAttribute('data-group', kept.indexOf(r.seriesKey) > -1 ? r.seriesKey : '');
      });

      var allLabel = this.getAttribute('data-all-label') || 'All';
      var html = '<button type="button" class="mp__pill" data-group="" aria-pressed="true">' + allLabel +
        '<span class="mp__pill-count">' + this.rows.length + '</span></button>';

      kept.forEach(function (k) {
        html += '<button type="button" class="mp__pill" data-group="' + k + '" aria-pressed="false">' +
          labels[k] + '<span class="mp__pill-count">' + counts[k] + '</span></button>';
      });

      this.pillWrap.innerHTML = html;
    }

    // Phone brand pages: one pill per series, and nothing is ever dropped. Pills
    // past the limit sit behind a "+N more" button instead of disappearing.
    // When one family is nearly the whole page (iPhone, Pixel, Nothing Phone) a
    // family pill would be useless, so that family is split by generation:
    // iPhone 17, iPhone 16 ... newest first.
    buildPhonePills() {
      if (!this.pillWrap || this.rows.length === 0) return;

      var rows = this.rows;
      var famCount = {};
      rows.forEach(function (r) { famCount[r.phone.key] = (famCount[r.phone.key] || 0) + 1; });

      var topKey = Object.keys(famCount).sort(function (a, b) { return famCount[b] - famCount[a]; })[0];
      var topGens = {};
      rows.forEach(function (r) { if (r.phone.key === topKey) topGens[r.phone.gen] = 1; });
      var splitTop = famCount[topKey] >= 10 && famCount[topKey] / rows.length >= 0.7 &&
        Object.keys(topGens).length > 1;

      var groups = {};
      var add = function (r, key, label, order) {
        if (!groups[key]) groups[key] = { key: key, label: label, count: 0, order: order, min: 999, max: 0 };
        var g = groups[key];
        g.count++;
        if (r.phone.numbered && r.phone.gen) {
          g.min = Math.min(g.min, r.phone.gen);
          g.max = Math.max(g.max, r.phone.gen);
          g.brand = r.phone.brand;
        }
        r.groupKey = key;
      };

      rows.forEach(function (r) {
        var p = r.phone;

        if (splitTop && p.key === topKey) {
          var name = p.numbered ? (p.brand || 'Series') : p.family;
          if (p.gen > 0) add(r, p.key + '-' + p.gen, name + ' ' + p.gen, 1000 - p.gen);
          else if (p.gen === -1) add(r, p.key + '-se', name + ' SE', 2000);
          else if (p.gen === -2) add(r, p.key + '-x', name + ' X', 2001);
          else add(r, 'other', 'Other', 9000);
          return;
        }

        add(r, p.key, p.family, splitTop ? 5000 : 0);
      });

      // Families with a single model would each cost a pill; they share one.
      var singles = Object.keys(groups).filter(function (k) { return groups[k].count === 1 && k !== 'other'; });
      if (singles.length > 1 || (singles.length === 1 && groups.other)) {
        rows.forEach(function (r) {
          if (singles.indexOf(r.groupKey) > -1) {
            delete groups[r.groupKey];
            add(r, 'other', 'Other', 9000);
          }
        });
        singles.forEach(function (k) { delete groups[k]; });
      }
      if (groups.other) { groups.other.order = 9000; groups.other.label = 'Other'; }

      var list = Object.keys(groups).map(function (k) {
        var g = groups[k];
        if (k === 'numbered') {
          var who = g.brand || 'Number series';
          g.label = g.max > g.min ? who + ' ' + g.min + ' to ' + g.max : who + ' ' + g.max;
        }
        return g;
      }).sort(function (a, b) {
        if (a.order !== b.order) return a.order - b.order;
        if (b.count !== a.count) return b.count - a.count;
        return a.label < b.label ? -1 : 1;
      });

      if (list.length < 2) {
        this.pillWrap.hidden = true;
        return;
      }

      var self = this;
      list.forEach(function (g, i) { self.seriesOrder[g.key] = i; });
      rows.forEach(function (r) {
        r.setAttribute('data-group', r.groupKey);
        r.seriesKey = r.groupKey;
      });

      var small = window.matchMedia('(max-width: 699px)').matches;
      var max = small
        ? (parseInt(this.getAttribute('data-max-pills-mobile'), 10) || 6)
        : (parseInt(this.getAttribute('data-max-pills'), 10) || 12);
      // Hiding a single pill behind a button saves nothing.
      if (list.length - max < 2) max = list.length;

      var allLabel = this.getAttribute('data-all-label') || 'All';
      var html = '<button type="button" class="mp__pill" data-group="" aria-pressed="true">' + allLabel +
        '<span class="mp__pill-count">' + rows.length + '</span></button>';

      list.forEach(function (g, i) {
        html += '<button type="button" class="mp__pill' + (i >= max ? ' mp__pill--extra' : '') +
          '" data-group="' + g.key + '" aria-pressed="false">' + g.label +
          '<span class="mp__pill-count">' + g.count + '</span></button>';
      });

      if (list.length > max) {
        var more = '+' + (list.length - max) + ' more series';
        html += '<button type="button" class="mp__more" data-mp-more aria-expanded="false" data-more="' +
          more + '" data-less="Show fewer">' + more + '</button>';
      }

      this.pillWrap.classList.add('mp__pills--wrap');
      this.pillWrap.setAttribute('data-open', 'false');
      this.pillWrap.innerHTML = html;
    }

    // Newest first inside each numbering line, so an iPhone page reads
    // 17 Pro Max, 17 Pro, 17 Air, 17, 17e, 16 Pro Max... and a Samsung page
    // keeps its S and A runs apart because their numbers are unrelated.
    sortRows() {
      if (!this.grid || this.rows.length < 2) return;

      var order = this.seriesOrder;
      var lineRank = {};
      var last = 999;

      this.rows.forEach(function (r) {
        var idx = order[r.seriesKey];
        if (idx === undefined) idx = last;
        if (lineRank[r.lineKey] === undefined || idx < lineRank[r.lineKey]) {
          lineRank[r.lineKey] = idx;
        }
      });

      var sorted = this.rows.slice().sort(function (a, b) {
        var la = lineRank[a.lineKey];
        var lb = lineRank[b.lineKey];

        if (la !== lb) return la - lb;
        if (a.generation !== b.generation) return b.generation - a.generation;
        if (a.rank !== b.rank) return b.rank - a.rank;

        return a.squished < b.squished ? -1 : 1;
      });

      var frag = document.createDocumentFragment();
      sorted.forEach(function (r) { frag.appendChild(r); });

      this.grid.appendChild(frag);
      this.rows = sorted;
    }

    observe() {
      if (!this.classList.contains('mp--animate')) return;

      if (!('IntersectionObserver' in window)) {
        this.rows.forEach(function (r) { r.classList.add('is-in'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

      this.rows.forEach(function (r) { io.observe(r); });
    }

    watchFab() {
      if (!this.fab || !this.grid) return;

      var self = this;
      var ticking = false;

      this.updateFab = function () {
        ticking = false;

        var grid = self.grid.getBoundingClientRect();
        var anchor = (self.toolbar || self.grid).getBoundingClientRect();
        var inView = grid.top < window.innerHeight && grid.bottom > 0;
        var past = anchor.bottom < 0;

        self.setAttribute('data-fab', inView && past ? 'true' : 'false');
      };

      var request = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(self.updateFab);
        }
      };

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(request, { threshold: [0, 0.01, 1] });
        io.observe(this.grid);
        if (this.toolbar) io.observe(this.toolbar);
      }

      this.updateFab();
    }

    apply() {
      var raw = this.input ? this.input.value.trim().toLowerCase() : '';
      var q = squish(raw);
      var group = this.group;
      var legacy = this.legacyGroup;
      var visible = 0;
      var i = 0;

      this.rows.forEach(function (r) {
        var okText = !q || r.squished.indexOf(q) !== -1;
        var okGroup = !group || (legacy ? r.classicKey === group
          : (r.getAttribute('data-group') === group || r.seriesKey === group));
        var show = okText && okGroup;
        r.hidden = !show;
        if (show) {
          r.style.setProperty('--i', Math.min(i, 24));
          if (q || group) r.classList.add('is-in');
          i++;
          visible++;
        }
      });

      this.setAttribute('data-empty', visible === 0 ? 'true' : 'false');
      this.setAttribute('data-has-query', raw ? 'true' : 'false');
      if (this.countEl) this.countEl.textContent = visible;
    }

    onKey(event) {
      if (event.key === 'Escape') {
        this.input.value = '';
        this.apply();
        return;
      }

      var visibleRows = this.rows.filter(function (r) { return !r.hidden; });

      if (event.key === 'Enter' && visibleRows[0]) {
        event.preventDefault();
        window.location.href = visibleRows[0].getAttribute('href');
        return;
      }

      if (event.key === 'ArrowDown' && visibleRows[0]) {
        event.preventDefault();
        visibleRows[0].focus();
      }
    }
  });
})();
